import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import Background from './Background';
import PersonalCabinetHeader from './PersonalCabinetHeader';
import AppSidebar from './AppSidebar';
import MainContent from './MainContent';
import Footer from './Footer';
import MandatoryPollDialog from '../MandatoryPollDialog';
import { useSidebarCollapsed } from '../../hooks';

interface PersonalCabinetLayoutProps {
  children: React.ReactNode;
}

const PersonalCabinetLayout: React.FC<PersonalCabinetLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  // Свёрнутый сайдбар отдаёт место контенту — как в админке
  const { collapsed: sidebarCollapsed, toggle: toggleSidebar } = useSidebarCollapsed('appSidebarCollapsed');

  // Sync i18n with user locale on mount and user change
  useEffect(() => {
    const targetLocale = user?.locale || localStorage.getItem('locale') || 'ru';
    if (i18n.language !== targetLocale) {
      i18n.changeLanguage(targetLocale);
    }
  }, [user?.locale, i18n]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Background>
      {/* Main content wrapper */}
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <PersonalCabinetHeader
          onDrawerToggle={handleDrawerToggle}
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={toggleSidebar}
        />
        <AppSidebar
          mobileOpen={mobileOpen}
          onDrawerToggle={handleDrawerToggle}
          collapsed={sidebarCollapsed}
        />
        {/* fullWidth только на десктопе по смыслу: на мобиле MainContent и так во всю ширину */}
        <MainContent fullWidth={sidebarCollapsed}>{children}</MainContent>
      </div>
      {/* Footer */}
      <Footer />
      {/* Mandatory poll - blocks UI until user votes */}
      <MandatoryPollDialog />
    </Background>
  );
};

export default PersonalCabinetLayout;
